import { clearParams } from 'framework/utils/clearParams';
import { ISalesQueryParams } from 'gen/ApiClient';
import { SalesParamsExclusions } from './SalesParamsExclusions';

export const clearSalesFilterParams = (pars: ISalesQueryParams): ISalesQueryParams => {
	return clearParams(pars, SalesParamsExclusions);
};
